function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* @indexer:no-export */
import * as React from 'react';
import modifyClassnames from '../../utils/modifyClassnames';
import cs from 'classnames';
import AnchorButton from '../../Buttons/AnchorButton/AnchorButton';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import TableGroup from '../TableGroup/TableGroup';
import { getAdditionalProps } from '../utils';
export var getTfootProps = getAdditionalProps('dm-table__footer', function (state, rowInfo, column, _ref) {
  var _ref$props = _ref.props,
    data = _ref$props.data,
    onFetchAllPages = _ref$props.onFetchAllPages,
    onFetchNextPage = _ref$props.onFetchNextPage,
    customPageSize = _ref$props.customPageSize,
    initialSize = _ref$props.initialSize,
    collectionSize = _ref$props.collectionSize,
    nameSpace = _ref$props.nameSpace,
    pagination = _ref$props.pagination;
  var currentSize = data.length;
  var showMore = pagination && currentSize && currentSize < collectionSize && collectionSize > initialSize;
  return {
    pagination: pagination,
    nameSpace: nameSpace,
    onFetchNextPage: onFetchNextPage,
    onFetchAllPages: onFetchAllPages,
    customPageSize: customPageSize,
    initialSize: initialSize,
    collectionSize: collectionSize,
    currentSize: currentSize,
    showMore: showMore
  };
});
var TfootComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(TfootComponent, _React$Component);
  function TfootComponent() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TfootComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TfootComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.renderButtons = function () {
      var _this$props = _this.props,
        currentSize = _this$props.currentSize,
        onFetchNextPage = _this$props.onFetchNextPage,
        onFetchAllPages = _this$props.onFetchAllPages,
        collectionSize = _this$props.collectionSize,
        customPageSize = _this$props.customPageSize,
        showMore = _this$props.showMore,
        nameSpace = _this$props.nameSpace;
      if (showMore) {
        var remainingItems = collectionSize - currentSize;
        var increment = remainingItems < customPageSize ? remainingItems : customPageSize;
        // could use more pages
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnchorButton, {
          className: cs('dm-table__pagination', 'dm-table__pagination--next', 'auto-paginate-next', _defineProperty({}, "auto-paginate-next--".concat(nameSpace), nameSpace)),
          onClick: onFetchNextPage
        }, /*#__PURE__*/React.createElement(ButtonLabel, {
          i18nKey: "@dm/components.table.show-more",
          i18n: {
            values: {
              increment: increment
            }
          }
        })), /*#__PURE__*/React.createElement(AnchorButton, {
          className: cs('dm-table__pagination', 'dm-table__pagination--all', 'auto-paginate-all', _defineProperty({}, "auto-paginate-all--".concat(nameSpace), nameSpace)),
          onClick: onFetchAllPages
        }, /*#__PURE__*/React.createElement(ButtonLabel, {
          i18nKey: "@dm/components.table.show-all"
        })));
      } else {
        return null;
      }
    };
    return _this;
  }
  _createClass(TfootComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        nameSpace = _this$props2.nameSpace,
        className = _this$props2.className;
      var buttons = this.renderButtons();
      if (!buttons) {
        return null;
      }
      return /*#__PURE__*/React.createElement(TableGroup, {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        role: "row",
        className: modifyClassnames('dm-table__row dm-table__row--footer', nameSpace)
      }, /*#__PURE__*/React.createElement("span", {
        role: "gridcell",
        className: modifyClassnames('dm-table__cell dm-table__cell--footer', nameSpace)
      }, buttons)));
    }
  }]);
  return TfootComponent;
}(React.Component);
export { TfootComponent as default };